export default __webpack_public_path__ + "media/images/datatables/resources/details_open-231338f592a17b06f412f07423906457.png";